import React, { useMemo, useState } from 'react'

import { Checkbox, message } from 'antd'

import NoData from '@/components/NoData'
import { Personal } from '@/components/Personal'
import { isSuccess } from '@/httpRequest'
import { postGroupAdd } from '@/httpRequest/modules/imInfo/groupAdd'
import { getGroupMembers } from '@/httpRequest/modules/imInfo/groupMembers'
import { SearchInput } from '@/pages/MesperyIM/components/SearchInput'
import { useMessageAtom } from '@/pages/MesperyIM/store/message'
import DelSrc from '@img/components/del2.png'

import styles from './index.module.less'
import useSessionListUsers from '../../hooks/useSessionListUsers'

interface IProps {}

export const letters = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z'
]

const AddGroupMembersPane: React.FC<IProps> = () => {
  const { setShowAddGroupMembers, currentConversation, setMembers, members } =
    useMessageAtom()
  const [userIds, setUserIds] = useState<string[]>([])
  const [searchVal, setSearchVal] = useState('')
  const { sessionListUsers } = useSessionListUsers()

  const userList = useMemo(() => {
    const sortData = sessionListUsers
      ?.filter(
        (item) => !members.some((mem) => mem.user_id === item.session_id)
      )
      .sort((a, b) => a.session_name?.localeCompare(b.session_name || '') || 0)

    letters.forEach((preFix) => {
      const index = sortData?.findIndex(
        (data) => data.session_name?.toLocaleUpperCase()[0] === preFix
      )
      if (index && index !== -1 && sortData) {
        sortData[index].preFix = preFix
      }
    })

    return sortData
  }, [sessionListUsers, members])

  const handleSelect = (id: string) => {
    if (userIds.includes(id)) {
      setUserIds(userIds.filter((item) => item !== id))
    } else {
      setUserIds([...userIds, id])
    }
  }

  const handleGetGroupMembers = async (group_id: string) => {
    const resp = await getGroupMembers({ group_id })

    if (isSuccess(resp)) {
      setMembers(resp.data.users)
      setShowAddGroupMembers(false)
    }
  }

  const handleConfirm = async () => {
    const resp = await postGroupAdd({
      group_id: currentConversation?.session_id || '',
      user_ids: userIds.join(',')
    })

    if (isSuccess(resp)) {
      handleGetGroupMembers(currentConversation?.session_id || '')
      message.success('success')
    }
  }

  return (
    <>
      <div className="step1-left">
        <div className="search-box">
          <SearchInput
            value={searchVal}
            onChange={(e) => {
              setSearchVal(e.target.value)
            }}
          />
        </div>

        {userList?.some(
          (item) => item.session_name?.indexOf(searchVal) !== -1
        ) ? (
          <div className={`${styles.ContactList} scroll-box`}>
            <ul>
              {userList.map((item) => {
                return (
                  <div
                    key={item.session_id}
                    className={`${
                      item.session_name?.indexOf(searchVal) !== -1
                        ? ''
                        : 'g-hidden'
                    }`}
                    onClick={() => {
                      handleSelect(item.session_id || '')
                    }}
                  >
                    {item.preFix && <div className="letter">{item.preFix}</div>}
                    <li>
                      <Checkbox
                        className="ml4 mr10 c-radio"
                        value={item.session_id}
                        checked={userIds.includes(item.session_id || '')}
                      />
                      <Personal
                        nickname={item.session_name}
                        avatar={item.session_avatar_url}
                        userData={{}}
                      />
                    </li>
                  </div>
                )
              })}
            </ul>
          </div>
        ) : (
          <div style={{ marginTop: 200 }}>
            <NoData tip="​Sorry, we couldn't find any results for your search." />
          </div>
        )}
      </div>
      <div className="step1-right">
        <div className={`${styles.ContactList} scroll-box`}>
          <ul>
            {userList?.map((item) => {
              return userIds.includes(item.session_id || '') ? (
                <li key={item.session_id}>
                  <Personal
                    nickname={item.session_name}
                    avatar={item.session_avatar_url}
                    userData={{}}
                  />
                  <a>
                    <img
                      src={DelSrc}
                      width={18}
                      onClick={() => {
                        setUserIds(
                          userIds.filter((userId) => userId !== item.session_id)
                        )
                      }}
                    />
                  </a>
                </li>
              ) : null
            })}
          </ul>
        </div>
        {/* 按钮 */}
        <div className="footer">
          <button
            className="g-btn mr20"
            onClick={() => setShowAddGroupMembers(false)}
          >
            Cancel
          </button>
          <button
            className="g-btn g-btn-primary mr20"
            onClick={handleConfirm}
            disabled={userIds.length === 0}
          >
            Confirm
          </button>
        </div>
      </div>
    </>
  )
}

export default AddGroupMembersPane
